export const PAGEID = 60;
export const RECORDS_PER_PAGE = 15;
export const NEW_RECORDS_PER_PAGE = 1; // We need this to make sure to only request the records from BE that we can show RECORDS_PER_PAGE - NEW_RECORDS_PER_PAGE

export const PERSONS_VENDORS = { idPage: PAGEID, idPackages: [651] };
export const WORK_EXPERIENCE = 'workExperience';
export const BOARD_SEATS = 'boardSeats';
export const WORK_AND_BOARD = 'workExpAndBoardSeat';

export const DROPDOWN_LIMIT = 200;

export const ROUTES = {
  root: {
    path: 'person',
    uri: '/person',
  },
  tableView: {
    path: 'table-view',
    uri: '/person/table-view',
  },
  detailView: {
    path: ':personId',
    uri: (personId) => `/person/${personId}`,
  },
  detailViewTabs: {
    generalInfo: {
      path: 'general-info',
      uri: (personId) => `/person/${personId}/general-info`,
    },
    workExperiences: {
      path: 'work-experiences',
      uri: (personId) => `/person/${personId}/work-experiences`,
    },
    education: {
      path: 'education',
      uri: (personId) => `/person/${personId}/education`,
    },
    boardSeats: {
      path: 'board-seats',
      uri: (personId) => `/person/${personId}/board-seats`,
    },
    externalMappings: {
      path: 'external-mappings',
      uri: (personId) => `/person/${personId}/external-mappings`,
    },
  },
};

export const STATUS_OPTIONS = {
  current: 1,
  former: 2,
};

export const OPTIONS = {
  status: [
    { label: 'current', value: STATUS_OPTIONS.current },
    { label: 'former', value: STATUS_OPTIONS.former },
  ],
};

export const LINKEDIN_URL = 'linkedin.com/in/';

export const dateFormat = 'MM/YYYY';
export const backendDateFormat = 'YYYY-MM-DD';

// data-sync-job and data-admin-job write person edits as idUser 1; cbi-entity-service
// previously excluded 2 and 31 from advancing ts_user_modified before that check moved here.
export const AUTOMATED_USER_IDS = new Set([1, 2, 31]);

export const C_LEVEL_TITLE_IDS = new Set([
  14, // CEO - Chief Executive Officer
  15, // CFO - Chief Financial Officer
  19, // CIO - Chief Information Officer
  20, // COO - Chief Operating Officer
  22, // CSO - Chief Security Officer
  23, // CTO - Chief Technology Officer
  72, // CPO - Chief Product Officer
  73, // CMO - Chief Marketing Officer
  76, // CPPLO - Chief People Officer
  77, // CRO - Chief Revenue Officer
  78, // CCOMO - Chief Commercial Officer
  79, // CCO - Chief Compliance Officer
  80, // CINVO - Chief Investment Officer
  81, // CA - Chief Architect
  82, // CMEDO - Chief Medical Officer
  83, // CAO - Chief Administrative Officer
  97, // CSTYO - Chief Strategy Officer
  98, // CDGTO - Chief Digital Officer
  99, // CLO - Chief Legal Officer
  100, // CRSKO - Chief Risk Officer
  101, // CISO - Chief Information Security Officer
  102, // CDO - Chief Data Officer
  103, // CAIO - Chief AI Officer
  104, // CANO - Chief Analytics Officer
  105, // CSLSO - Chief Sales Officer
  106, // CGRO - Chief Growth Officer
  107, // CCUSO - Chief Customer Officer
  108, // CEXPO - Chief Experience Officer
  109, // CBO - Chief Business Officer
  110, // CBRDO - Chief Brand Officer
  111, // CCOMSO - Chief Communications Officer
  112, // CCNTO - Chief Content Officer
  113, // CCREO - Chief Creative Officer
  114, // CDESO - Chief Design Officer
  115, // CHRO - Chief Human Resources Officer
  116, // CTLTO - Chief Talent Officer
  117, // CCULO - Chief Culture Officer
  118, // CDIVO - Chief Diversity Officer
  119, // CINNO - Chief Innovation Officer
  120, // CTRNO - Chief Transformation Officer
  121, // CSUSO - Chief Sustainability Officer
  122, // CPRCO - Chief Procurement Officer
  123, // CSCHO - Chief Supply Chain Officer
  124, // CLGSO - Chief Logistics Officer
  125, // CPRDO - Chief Production Officer
  126, // CACCO - Chief Accounting Officer
  127, // CQO - Chief Quality Officer
  128, // CDLVO - Chief Delivery Officer
  129, // CDEVO - Chief Development Officer
  130, // CPRGO - Chief Program Officer
  131, // CPPO - Chief Public Policy Officer
  132, // CRSTO - Chief Restructuring Officer
  133, // CCLNO - Chief Clinical Officer
  134, // CNO - Chief Nursing Officer
  135, // CPHAO - Chief Pharmacy Officer
  136, // CSCIO - Chief Scientific Officer
  137, // CPRVO - Chief Privacy Officer
  138, // CGLO - Chief Global Officer
  139, // CINTO - Chief Integration Officer
  140, // CRSPO - Chief Responsibility Officer
  141, // CAUTO - Chief Automation Officer
  142, // CIMPO - Chief Impact Officer
  143, // CINDO - Chief Industrial Officer
  144, // CFNDO - Chief Funding Officer
  145, // CRESO - Chief Resolution Officer
  146, // CRTLO - Chief Retail Officer
  147, // CSTRO - Chief Stores Officer
  148, // CCRDO - Chief Credit Officer
  149, // CLNDO - Chief Lending Officer
  150, // CCLMO - Chief Claims Officer
  151, // CRENO - Chief Reinsurance Officer
  152, // CUWRO - Chief Underwriting Officer
  153, // CVALO - Chief Valuation Officer
  154, // CAUDO - Chief Audit Officer
  155, // CEDUO - Chief Educational Officer
  156, // CBIO - Chief Biology Officer
  157, // CSUITE - C-Suite (generic fallback)
]);

export const DEPARTMENT_ENUM_TO_INT = {
  DEPARTMENT_UNSPECIFIED: 0,
  DEPARTMENT_ADMINISTRATIVE: 1,
  DEPARTMENT_BOARD: 2,
  DEPARTMENT_C_SUITE: 3,
  DEPARTMENT_CONSULTING: 4,
  DEPARTMENT_CUSTOMER_SERVICE: 5,
  DEPARTMENT_DESIGN: 6,
  DEPARTMENT_EDUCATION: 7,
  DEPARTMENT_ENGINEERING_AND_TECHNICAL: 8,
  DEPARTMENT_FINANCE_AND_ACCOUNTING: 9,
  DEPARTMENT_GENERAL_MANAGEMENT: 10,
  DEPARTMENT_HUMAN_RESOURCES: 11,
  DEPARTMENT_LEGAL: 12,
  DEPARTMENT_MARKETING: 13,
  DEPARTMENT_MEDICAL: 14,
  DEPARTMENT_OPERATIONS: 15,
  DEPARTMENT_OTHER: 16,
  DEPARTMENT_PRODUCT: 17,
  DEPARTMENT_PROJECT_MANAGEMENT: 18,
  DEPARTMENT_REAL_ESTATE: 19,
  DEPARTMENT_RESEARCH: 20,
  DEPARTMENT_SALES: 21,
  DEPARTMENT_TRADES: 22,
};

export const MANAGEMENT_LEVEL_ENUM_TO_INT = {
  MANAGEMENT_LEVEL_UNSPECIFIED: 0,
  MANAGEMENT_LEVEL_JUNIOR: 1,
  MANAGEMENT_LEVEL_MIDLEVEL: 2,
  MANAGEMENT_LEVEL_SENIOR: 3,
  MANAGEMENT_LEVEL_MANAGER: 4,
  MANAGEMENT_LEVEL_DIRECTOR: 5,
  MANAGEMENT_LEVEL_VP: 6,
  MANAGEMENT_LEVEL_C_LEVEL: 7,
  MANAGEMENT_LEVEL_BOARD: 8,
  MANAGEMENT_LEVEL_OWNER: 9,
  MANAGEMENT_LEVEL_FOUNDER: 10,
  MANAGEMENT_LEVEL_UNKNOWN: 11,
  MANAGEMENT_LEVEL_PRESIDENT: 12,
};
